import {ResourceDetachCommand} from './resource.detach.command';
import {ResourceAttachCommand} from './resource.attach.command';
import {ResourceMoveCommand} from './resource.move.command';
import {ResourceSwapCommand} from './resource.swap.command';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {Injectable} from '@angular/core';
import {CircularDepCrutch} from '../../core/helpers/circular-dep.crutch';
import {ResourceChangeRasciCommand} from './resource.rasci.command';
import {ResourceHideCommand} from './resource.hide.command';
import {ResourceSetMainCommand} from './resource.setMain.command';
import {ResourceChangePerRowCommand} from './resource.changePerRow.command';
import {SanitizeXssService} from '../../core/services/santize-xss.service';

@Injectable()
export class ResourceCommands extends CircularDepCrutch {
  public serviceObj: any;

  constructor(
    graphHelperSvc: GraphHelperService,
    editorRegistrySvc: EditorRegistryService,
    registry: EditorRegistryService,
    sanitizeXssService: SanitizeXssService
  ) {
    super();
    /** Additional services injected in ResourceCommandService & DiagramUpdateService **/
    this.serviceObj = {
      graphHelperSvc,
      editorRegistrySvc,
      registry,
      sanitizeXssService
    };
  }

  public attach(data) {
    return new ResourceAttachCommand(data).injectServices(this.serviceObj);
  }

  public detach(data) {
    return new ResourceDetachCommand(data).injectServices(this.serviceObj);
  }

  public move(data) {
    return new ResourceMoveCommand(data).injectServices(this.serviceObj);
  }

  public swap(data) {
    return new ResourceSwapCommand(data).injectServices(this.serviceObj);
  }

  public changeRasci(data, newRasci) {
    return new ResourceChangeRasciCommand(data, newRasci).injectServices(this.serviceObj);
  }

  public changeVisibility(data) {
    return new ResourceHideCommand(data).injectServices(this.serviceObj);
  }

  public changeMain(data) {
    return new ResourceSetMainCommand(data).injectServices(this.serviceObj);
  }

  public changeResourcesPerRow(data) {
    return new ResourceChangePerRowCommand(data).injectServices(this.serviceObj).prepareData();
  }
}
